import format from "date-fns/format";
import React from "react";
import styled, { css } from "styled-components";
import { getDateIsoString } from "@lifeat/shared/util/DateUtil";
import { Signal, signal, useComputed } from "@preact/signals-react";
import { FontSize } from "@themes/Fonts";
import { ClientTaskListType, IdentifiableTask } from "../../TaskManagementTypes";
import TaskList from "../../components/TaskList";
import { TASK_COL_WIDTH } from "./PlannerConstants";

const DateColumnContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: ${TASK_COL_WIDTH}px;
    padding: 10px 0;
    height: 100%;
`;

const TaskDateColumnHeader = styled.div<{ isToday: boolean }>`
    display: flex;
    font-size: ${FontSize.medium};
    padding: 4px 6px;
    border-radius: 7px;
    ${(props) =>
        props.isToday &&
        css`
            background-color: ${props.theme.textColorPrimary};
        `}
    color: ${(props) => (props.isToday ? props.theme.backgroundPrimary : props.theme.textColorPrimary)};
    margin: 0 25px;
`;

const TaskDateColumnHeaderBold = styled.div`
    font-weight: 550;
`;

const now$ = signal(new Date());

setInterval(() => {
    now$.value = new Date();
}, 1000);

interface PlannerDateColumnProps {
    index: number;
    data: {
        highestOrderRankTask$: Signal<IdentifiableTask | null>;
        dateRange: Date[];
        dateTaskListMap$: Signal<Record<string, ClientTaskListType>>;
    };
}
const PlannerDateColumn = ({
    index,
    data: { highestOrderRankTask$, dateRange, dateTaskListMap$ },
}: PlannerDateColumnProps) => {
    const date = dateRange[index];
    const isToday$ = useComputed(() => getDateIsoString(date) === getDateIsoString(now$.value));
    const taskList$ = useComputed(() => dateTaskListMap$.value[getDateIsoString(date)] ?? {});
    if (date == null) {
        return <div />;
    }
    return (
        date && (
            <DateColumnContainer>
                <TaskDateColumnHeader isToday={isToday$.value}>
                    <TaskDateColumnHeaderBold>{format(date, "EEE d")}</TaskDateColumnHeaderBold>
                    {format(date, ", MMM")}
                </TaskDateColumnHeader>
                <TaskList
                    taskList$={taskList$}
                    amplitudeEventSource="board-view"
                    showProgressBar={isToday$.value}
                    dateColumnProps={{
                        date: date,
                        highestOrderRankTask: highestOrderRankTask$.value,
                    }}
                />
            </DateColumnContainer>
        )
    );
};

export default PlannerDateColumn;
